import { useEffect, useState } from "react";
import { Plus, Trash2, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/common";
import { AssistantChat } from "@/components/assistant/AssistantChat";
import { useAssistantChat } from "@/hooks/useAssistantChat";
import { api, fmtDate } from "@/lib/api";

function ConversationList({ chat }) {
  const [items, setItems] = useState([]);
  const load = () => api.get("/ai/conversations").then((r) => setItems(r.data));
  useEffect(() => { load(); }, [chat.version]);

  const remove = async (id) => {
    await api.delete(`/ai/conversations/${id}`);
    if (chat.conv?.id === id) chat.setConv(null);
    load();
  };

  return (
    <aside className="flex min-h-0 flex-col rounded-md border bg-white shadow-sm" data-testid="conversation-list">
      <div className="border-b p-3"><Button className="h-11 w-full gap-2" onClick={chat.reset} data-testid="assistant-new-conversation"><Plus className="h-4 w-4" /> Nouvelle conversation</Button></div>
      <ul className="flex-1 overflow-y-auto p-2">
        {items.length === 0 && <li className="p-3 text-sm text-slate-500">Aucune conversation.</li>}
        {items.map((c) => (
          <li key={c.id} className={`group flex items-center gap-1 rounded ${chat.conv?.id === c.id ? "bg-slate-100" : "hover:bg-slate-50"}`}>
            <button type="button" onClick={() => chat.open(c.id)} className="flex min-w-0 flex-1 items-start gap-2 px-3 py-2.5 text-left" data-testid={`conversation-item-${c.id}`}>
              <MessageSquare className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" />
              <span className="min-w-0"><span className="block truncate text-sm font-medium">{c.title}</span><span className="text-xs text-slate-400">{fmtDate(c.updated_at)}</span></span>
            </button>
            <Button variant="ghost" className="h-10 w-10 shrink-0 p-0 text-slate-400 opacity-0 hover:text-rose-600 group-hover:opacity-100" onClick={() => remove(c.id)} data-testid={`conversation-delete-${c.id}`}><Trash2 className="h-4 w-4" /></Button>
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default function Assistant() {
  const chat = useAssistantChat();
  return (
    <div data-testid="assistant-page">
      <PageHeader title="Assistant IA" subtitle="Instructions en français, au clavier ou à la voix. L'IA propose, vous validez." testid="assistant-title" />
      <div className="grid h-[calc(100vh-15rem)] min-h-[520px] grid-cols-1 gap-4 lg:grid-cols-[280px_1fr]">
        <div className="hidden min-h-0 lg:flex lg:flex-col"><ConversationList chat={chat} /></div>
        <div className="min-h-0 overflow-hidden rounded-md border shadow-sm"><AssistantChat chat={chat} /></div>
      </div>
    </div>
  );
}
